module.exports = __webpack_public_path__ + "static/media/bannerDeporteMarzo.839194eb.jpg";